import React, { createContext, useContext, useState } from "react";
const ContactPopupContext = createContext();
const HamburgerProvider = ({ children }) => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isCompactContactOpen, setIsCompactContactOpen] = useState(false);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const [isPaginationOpen, setIsPaginationOpen] = useState(false);
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  return (
    <ContactPopupContext.Provider
      value={{
        isContactOpen,
        isCategoriesOpen,
        isPaginationOpen,
        setIsContactOpen,
        isCompactContactOpen,
        setIsCompactContactOpen,
        setIsCategoriesOpen,
        setIsPaginationOpen,
        isPricingOpen,
        setIsPricingOpen,
      }}
    >
      {children}
    </ContactPopupContext.Provider>
  );
};
const useHamburger = () => useContext(ContactPopupContext);
export { useHamburger };
export default HamburgerProvider;
